const state = {
    followupIndicators: [],
    sections: {
        locked: {},
        indicatorsComplete: {}
    },
    savingIndicator: false,
    authUserRoles: [],
}

const actions = {
    fetchFollowupIndicators (context, data) {
        axios.get('/api/followup-indicators', {params: data})
        .then( (response) => {
            context.commit("setFollowupIndicators", response.data)
            lockSections(context, response.data)
            completeSectionIndicators(context, response.data)
        })
        .catch( (e) => {
            console.log("Error: followup.js, fetchFollowupIndicators(), "+ e.message)          
        })
    },
    saveFollowupIndicator (context, data) {
        if (context.state.savingIndicator) {
            return
        }

        context.state.savingIndicator = true

        axios.post('/api/followup-indicator', data)
        .then( (response) => {
            context.commit("setFollowupIndicators", response.data)
            completeSectionIndicators(context, response.data)
        })
        .catch( (e) => {
            console.log("Error: followup.js, saveIndicator(), "+ e.message)          
        })
        .finally(() => {
            context.state.savingIndicator = false
        })
    },
    lockIndicators (context, data) {
        axios.post('/api/followup-indicators-lock', data)
        .then( (response) => {
            context.commit("setFollowupIndicators", response.data)
            lockSections(context, response.data)
        })
        .catch( (e) => {
            console.log("Error: followup.js, lockIndicators(), "+ e.message)          
        })
    },
    unlockIndicators (context, data) {
        axios.post('/api/followup-indicators-unlock', data)
        .then( (response) => {
            context.commit("setFollowupIndicators", response.data)
            lockSections(context, response.data)     
        })
        .catch( (e) => {
            console.log("Error: initial.js, lockIndicators(), "+ e.message)          
        })
    },
    fetchAuthUserRoles (context) {
        axios.get("api/user-roles")
        .then( (response) => {
            context.commit("setAuthUserRoles", response.data)
        })
        .catch( (e) => {
            console.log("Error: followup.js, fetchAuthUserRoles()"+ e.message)          
        })
    }
}

const mutations = {
    setFollowupIndicators (state, data) {
        return state.followupIndicators = data
    },
    setSectionLocked (state, data) {
        return state.sections.locked[data.section_number] = data.locked
    },
    setSectionIndicatorsComplete (state, data) {
        if (!state.sections.indicatorsComplete[data.section_number]) {
            state.sections.indicatorsComplete[data.section_number] = {}
        }
        return state.sections.indicatorsComplete[data.section_number][data.indicator_number] = data.grade
    },
    setAuthUserRoles (state, data) {
        return state.authUserRoles = data
    }
}

const getters = {
    //
}

function lockSections (context, sections) {
    for (const [key, value] of Object.entries(sections)) {
        const valueKeys = Object.keys(value);
        const firstValueKey = valueKeys[0];
        if (value[firstValueKey] && value[firstValueKey]['locked_at']) {
            context.commit("setSectionLocked", {section_number: key, locked: true})
        } else {
            context.commit("setSectionLocked", {section_number: key, locked: false})
        }
    }
}

function completeSectionIndicators (context, sections) {
    for (const [key, value] of Object.entries(sections)) {
        let count = 0
        Object.values(value).forEach(val => {
            context.commit("setSectionIndicatorsComplete", {section_number: val.section_number, indicator_number: val.indicator_number, grade: val.grade})
        });
    } 
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}